import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormMultilineInput.module.css";
import {TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";

const FormMultilineInput = ({
                                  label,
                                  initValue,
                                  widthLimit,
                                  controlRef,
                                  placeholder,
                                  maxVisibleRows = 4,
                                  validateTextFunc,
                                  tipText,
                                  readOnly,
                              }) => {

    const inputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")

    const correctedWidthLimit = widthLimit === undefined ? 10000 : widthLimit;

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getValue: getText,
                getText: getText,
                validateNotEmpty: validateNotEmpty,
                validateLength: validateLength,
                validateText: validateText,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getText() {
        return inputRef.current.value.trim();
    }

    function validateNotEmpty(errorMessage) {
        if (getText().length > 0)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function validateLength(maxLength, errorMessage = undefined) {
        const textLength = getText().length;
        if (textLength <= maxLength)
            return true;
        setErrorMessage(errorMessage ?? `Слишком длинный текст! (нужно укоротить на ${textLength - maxLength} символ(ов))`);
        return false;
    }

    function validateText(errorMessage) {
        if (!validateTextFunc || validateTextFunc(getText()))
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <TextField
                type="text"
                variant="outlined"
                multiline
                minRows={2}
                maxRows={maxVisibleRows}
                hiddenLabel
                inputRef={inputRef}
                defaultValue={initValue}
                placeholder={placeholder}
                error={errorMessage !== ""}
                helperText={errorMessage}
                sx={{width: `min(${correctedWidthLimit}px, 100%)`}}
                slotProps={{
                    /*htmlInput: {
                        sx: { backgroundColor: "white", borderRadius: "4px" }
                    },*/
                    input: {
                        readOnly: readOnly,
                        sx: {
                            backgroundColor: readOnly ? "#ffff0018" : "white",
                            borderRadius: "4px",
                        }
                    }
                }}
                onChange={() => {
                    if (errorMessage)
                        setErrorMessage("")
                }}
            />
        </div>
    );
};

export default FormMultilineInput;